import { render, staticRenderFns } from "./ItemInstall.vue?vue&type=template&id=6f493e2e&"
import script from "./ItemInstall.vue?vue&type=script&lang=js&"
export * from "./ItemInstall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports